import React from "react";
import { useCatalogue } from "./use-catalogue";

/** Mount beside the Library link; inherits the host navigation's badge style. */
export default function LibraryPendingBadge({rtl=false,className="ms-2 inline-flex rounded-full bg-primary px-1.5 text-xs font-semibold text-primary-foreground"}:{rtl?:boolean;className?:string}){
 const resource=useCatalogue(),count=resource.data?.suggestions.filter(s=>s.status==="pending").length||0;
 return count?<span className={className} aria-label={rtl?`اقتراحات قيد المراجعة: ${count}`:`Pending suggestions: ${count}`}>{count}</span>:null;
}
